import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Tooltip,
  Divider,
  Space,
  message
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import ReactPlayer from "react-player/youtube";
import products from "../../../organisations/json/products.json";
import { deleteRequest, getRequest } from "../../../../api/http";
import userServiceApi from "../../../../api/userServiceApi";
import { toast } from "react-toastify";
import { truncateFilename } from "../../../../utils/helper"
import SynthesiaVideo from "./SynthesiaVideo";
const { TextArea } = Input;
const MAX_CHARACTERS = 700;

export default function ProductComponent({ dataLoader, form, getSingleTabData, loader: formDataLoader }) {
  const { micrositeId } = useParams();
  const { state } = useLocation();
  const inputRef = useRef(null);

  const tabKey = state;
  const { tabData, product_groups } = useStore();
  const whichTab = TAB_KEYS.product;
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage, updateFile } = useConnectsuForm();
  const [loader, setLoader] = useState(formDataLoader || true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();
  const navigate = useNavigate();
  const [customName, setName] = useState("");
  const [items, setItems] = useState(products.map((item) => item.name));

  const [showClear, setShowClear] = useState(false);
  const [clearEnabled, setClearEnabled] = useState(false);
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);


  useEffect(() => {
    if (tabData[whichTab]) {
      tabData[whichTab].forEach((item) => {
        if (item?.title && !items.includes(item.title)) {
          items.push(item.title);
        }
      });
    }
  }, [tabData[whichTab]]);


  const MakeFieldDisableHandler = (i) => {
    let value = form.getFieldValue([whichTab, i, "title"]);
    // if (value == "w1" || value == "w2" || value == "w3") {
    //   return true;
    // }
  };

  useEffect(() => {
    localStorage.setItem("tab", "PRODUCT");
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);

  const renderMedia = (dataItem) => {
    const commonStyles = {
      width: "350px",
      height: "250px",
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <iframe
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <img
            src={dataItem?.mediaLink?.url}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }

    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }

    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };
  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
  };

  const handleDeleteBrochure = async (id) => {
    try {
      const res = await deleteRequest(userServiceApi.deleteBrochure(id))
      if (res) {
        toast.success('Successfully Delete Brochure')
        getSingleTabData(tabKey, form)
      }
    } catch (error) {
      toast.error('Failed to Delete Brochure')
    }
  }

  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];

    // ✅ Prepend a fresh row
    const newList = [
      {
        assetTitleId: undefined,
        subTitle: "",
        description: "",
        mediaLink: { mediaType: undefined, url: "" },
        urlLink: "",
        BrochureFile: null,
        brochureFileName: "",
        brochureFilePath: "",
        media: null,
      },
      ...currentList,
    ];

    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);;
    // Scroll to top for visibility
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];

    // Reset unsaved rows
    const updatedList = currentList.map(item =>
      !item?.id
        ? {
          assetTitleId: undefined,
          subTitle: "",
          description: "",
          mediaLink: { mediaType: undefined, url: "" },
          urlLink: "",
          BrochureFile: null,
          brochureFileName: "",
          brochureFilePath: "",
          media: null,
        }
        : item
    );

    form.setFieldsValue({ [whichTab]: updatedList });

    // Recheck if any unsaved data still exists
    // refreshUnsavedState();
    setShowClear(false);
    setClearEnabled(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.product?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.product]);

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.subTitle?.trim() ||
        item?.description?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.media ||
        item?.BrochureFile;

      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };




  useEffect(() => {
    form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [tabData[whichTab]]);


  useEffect(() => {
    const unsubscribe = form.subscribe?.(() => {
      refreshUnsavedState();
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [form]);



  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {

    return (
      <div>
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <>

                  <Form.List
                    name={whichTab}
                    initialValue={
                      tabData && tabData[whichTab] && tabData[whichTab].length > 0
                        ? tabData[whichTab]
                        : [""]
                    }
                  >
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <div className="inputBody">
                            <label></label>
                            <div style={{ textAlign: "right" }}>
                              {hasUnsavedItem && (
                                <Button
                                  className="cancelBtn"
                                  type="button"
                                  onClick={handleClear}
                                >
                                  Clear
                                </Button>
                              )}

                              <Button
                                className="greenBtn"
                                onClick={handleAddMore}
                              >
                                Add <PlusOutlined />
                              </Button>
                            </div>
                          </div>

                          {fields.map(({ key, name, ...restField }, i) => {
                            return (
                              <div className="card-item" key={key}>
                                <Col
                                  className="gutter-row tabContent"
                                  span={16}
                                  style={{ paddingRight: "25px" }}
                                >
                                  <div className="d-flex">
                                    <Form.Item
                                      className="custom-work"
                                      {...restField}
                                      label="Product Group"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      name={[name, "assetTitleId"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Product group needs to be selected",
                                        },
                                      ]}
                                    >
                                      <Select
                                        name={[name, "assetTitleId"]}
                                        options={product_groups.map((item) => ({
                                          label: item.title,
                                          value: item.id,
                                        }))}
                                        dropdownRender={(menu) => (
                                          <>
                                            {menu}
                                            <Divider
                                              style={{ margin: "8px 0" }}
                                            />
                                            <Space
                                              style={{ padding: "0 8px 4px" }}
                                            >
                                              <Button
                                                className="dropdow-configurations-btn greenBtn"
                                                type="text"
                                                icon={<PlusOutlined />}
                                                onClick={() => {
                                                  localStorage.setItem(
                                                    "page",
                                                    "configurations"
                                                  );
                                                  navigate(
                                                    "/micrositeConfigurations",
                                                    {
                                                      state: {
                                                        micrositeId:
                                                          micrositeId,
                                                        page: "product",
                                                      },
                                                    }
                                                  );
                                                }}
                                              >
                                                Add product group
                                              </Button>
                                            </Space>
                                          </>
                                        )}
                                      />
                                    </Form.Item>

                                    <Form.Item>
                                      <div className="remove-btn">
                                        <DeleteOutlined
                                          title="Delete News"
                                          onClick={() => {
                                            const id = form.getFieldValue([
                                              whichTab,
                                              i,
                                              "id",
                                            ]);
                                            if (id) {
                                              deleteSingleItem(
                                                whichTab,
                                                id,
                                                form
                                              );
                                            } else {
                                              remove(name);
                                              setHasUnsavedItem(false);
                                              refreshUnsavedState();
                                              const currentList =
                                                form.getFieldValue(whichTab) ||
                                                [];
                                              if (currentList.length <= 1) {
                                                setShowClear(false);
                                                setClearEnabled(false);
                                              }
                                            }
                                          }}
                                        />
                                      </div>
                                    </Form.Item>
                                  </div>

                                  <Form.Item
                                    {...restField}
                                    label="Product"
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                    name={[name, "subTitle"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Product is required",
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Enter Sub product"
                                      maxLength={40}
                                      showCount={{
                                        formatter: ({ count }) => `${count}/40`,
                                      }}
                                      onChange={() => {
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                      onKeyDown={(e) => {
                                        const currentValue =
                                          form.getFieldValue([whichTab, name, "subTitle"]) || "";

                                        if (
                                          e.key.length === 1 && // normal characters only
                                          currentValue.length >= 40
                                        ) {
                                          form.setFields([
                                            {
                                              name: [whichTab, name, "subTitle"],
                                              errors: ["Title cannot exceed 40 characters"],
                                            },
                                          ]);
                                        }
                                      }}
                                      onBlur={() => {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "subTitle"],
                                            errors: [],
                                          },
                                        ]);
                                      }}
                                    />
                                  </Form.Item>


                                  <Form.Item
                                    label="Description"
                                    {...restField}
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                    name={[name, "description"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Description is required",
                                      },
                                      {
                                        max: MAX_CHARACTERS - 1,
                                        message: `Description should be less than ${MAX_CHARACTERS} characters`,
                                      },
                                    ]}
                                  >
                                    <TextArea
                                      placeholder="Enter Description"
                                      rows={5}
                                      maxLength={MAX_CHARACTERS}
                                      showCount
                                      onChange={() => {
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                    />
                                  </Form.Item>
                                  <div className="d-flex">
                                    <Form.Item
                                      {...restField}
                                      className="w-100"
                                      name={[name, "mediaLink", "mediaType"]}
                                      label="Video or Image"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                    >
                                      <Select
                                        onChange={() => {
                                          setShowClear(true);
                                          setClearEnabled(true);
                                        }}
                                        placeholder="Select Option"
                                      >
                                        <Select.Option value="VIMEO_MEDIA">
                                          Add Vimeo Link
                                        </Select.Option>
                                        <Select.Option value="SOCIAL_MEDIA">
                                          Add Youtube Link
                                        </Select.Option>
                                        <Select.Option value="SYNTHESIA_MEDIA">
                                          Add Synthesia Link
                                        </Select.Option>
                                        <Select.Option value="IMAGE">
                                          Upload Image
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                    <Form.Item>
                                      <div className="remove-btn">
                                        <Tooltip title="Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio">
                                          <QuestionCircleOutlined />
                                        </Tooltip>
                                      </div>
                                    </Form.Item>
                                  </div>
                                  {findValue(i, "type") === "SOCIAL_MEDIA" && (
                                    <Form.Item
                                      label="Youtube Link"
                                      {...restField}
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      name={[name, "mediaLink", "url"]}
                                    >
                                      <Input
                                        onChange={() => {
                                          setShowClear(true);
                                          setClearEnabled(true);
                                        }}
                                      />
                                    </Form.Item>
                                  )}

                                  {findValue(i, "type") === "VIMEO_MEDIA" && (
                                    <Form.Item
                                      label="Vimeo Link"
                                      {...restField}
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      name={[name, "mediaLink", "url"]}
                                    >
                                      <Input
                                        onChange={() => {
                                          setShowClear(true);
                                          setClearEnabled(true);
                                        }}
                                      />
                                    </Form.Item>
                                  )}

                                  {findValue(i, "type") === "IMAGE" && (
                                    <Form.Item
                                      {...restField}
                                      label="Image"
                                      colon={false}
                                      name="media"
                                      className="experienceImg"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                    >
                                      {/* ✅ Show preview if blob or URL exists */}
                                      {findValue(i, "blob") ? (
                                        <Avatar
                                          src={URL.createObjectURL(
                                            findValue(i, "blob")
                                          )}
                                          alt=""
                                        />
                                      ) : findValue(i, "url") ? (
                                        <Avatar
                                          src={findValue(i, "url")}
                                          alt=""
                                        />
                                      ) : (
                                        <Avatar src={UserIcon} />
                                      )}

                                      {/* ✅ File upload button */}
                                      <label className="fileUploadBtn greenBtn">
                                        Choose File
                                        <input
                                          accept="image/png, image/gif, image/jpeg"
                                          type="file"
                                          onChange={(e) => {
                                            updateImage(e, i, form, whichTab);
                                            setShowClear(true);
                                            setClearEnabled(true);
                                          }}
                                        />
                                      </label>
                                    </Form.Item>
                                  )}
                                  {findValue(i, "type") ===
                                    "SYNTHESIA_MEDIA" ? (
                                    <Form.Item
                                      label="Synthesia Link"
                                      labelCol={{ span: 6 }}
                                      {...restField}
                                      name={[name, "mediaLink", "url"]}

                                    >
                                      <Input />
                                    </Form.Item>
                                  ) : null}

                                  <Form.Item
                                    label="External Link"
                                    {...restField}
                                    className="w-100"
                                    name={[name, "urlLink"]}
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                  >
                                    <Input
                                      placeholder="External Link"
                                      onChange={() => {
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    {...restField}
                                    label="Brochure"
                                    name={[name, "BrochureFile"]}
                                    className="experienceImg w-100"
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                  >
                                    {form.getFieldValue(whichTab)?.[i]
                                      ?.BrochureFile ? (
                                      truncateFilename(
                                        form.getFieldValue(whichTab)[i]
                                          ?.BrochureFile?.name
                                      )
                                    ) : form.getFieldValue(whichTab)?.[i]
                                      ?.brochureFileName ? (
                                      <>
                                        <a
                                          href={
                                            form.getFieldValue(whichTab)[i]
                                              .brochureFilePath || "#"
                                          }
                                        >
                                          <Button
                                            type="button"
                                            icon={<DownloadOutlined />}
                                          >
                                            {truncateFilename(
                                              form.getFieldValue(whichTab)[i]
                                                ?.brochureFileName
                                            )}
                                          </Button>
                                        </a>
                                        <Button
                                          icon={<DeleteOutlined />}
                                          onClick={() =>
                                            form.getFieldValue(whichTab)[i]
                                              .id &&
                                            handleDeleteBrochure(
                                              form.getFieldValue(whichTab)[i].id
                                            )
                                          }
                                        />
                                      </>
                                    ) : (
                                      "No file chosen"
                                    )}
                                    <label
                                      className="fileUploadBtn greenBtn"
                                      style={{ position: "relative" }}
                                    >
                                      {form.getFieldValue(whichTab)?.[i]
                                        ?.brochureFileName
                                        ? "Upload New Brochure"
                                        : "Upload Brochure"}
                                      {/* <input
                                        type="file"
                                        accept="application/pdf"
                                        onChange={(e) => {
                                          updateFile(e, i, form, whichTab);
                                          setShowClear(true);
                                          setClearEnabled(true);
                                          setFormChanged(true);
                                        }}
                                      /> */}
                                      <input
                                        type="file"
                                        accept="application/pdf"
                                        onChange={(e) => {
                                          const file = e.target.files[0];

                                          if (!file) return; // no file selected

                                          // ✅ Check file type (MIME type + extension)
                                          const isPdf =
                                            file.type === "application/pdf" ||
                                            (file.name &&
                                              file.name
                                                .toLowerCase()
                                                .endsWith(".pdf"));

                                          if (!isPdf) {
                                            toast.error(
                                              "Only PDF files are allowed."
                                            );
                                            e.target.value = null; // clear invalid file
                                            return;
                                          }

                                          // ✅ Check file size (optional, e.g., 5MB max)
                                          const maxSize = 5 * 1024 * 1024; // 5 MB
                                          if (file.size > maxSize) {
                                            toast.error(
                                              "File size must be less than 5MB."
                                            );
                                            e.target.value = null;
                                            return;
                                          }

                                          // ✅ If valid, continue existing logic
                                          updateFile(e, i, form, whichTab);
                                          setShowClear(true);
                                          setClearEnabled(true);
                                          setFormChanged(true);
                                        }}
                                      />

                                      <div
                                        className="remove-btn"
                                        style={{
                                          left: "initial",
                                          right: "-30px",
                                        }}
                                      >
                                        <Tooltip title="Only PDF files are allowed. Please upload a PDF not larger than 5MB.">
                                          <QuestionCircleOutlined />
                                        </Tooltip>
                                      </div>
                                    </label>
                                  </Form.Item>

                                  {/* ✅ Save Button */}
                                  <Form.Item
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    {formChanged ? (
                                      <Button
                                        className="saveBtn greenBtn"
                                        onClick={() => {
                                          form.submit();
                                        }}
                                      >
                                        Save
                                      </Button>
                                    ) : (
                                      <Button
                                        className="saveBtn greenBtn"
                                        style={{
                                          opacity: 0.5,
                                          pointerEvents: "none",
                                        }}
                                      >
                                        Save
                                      </Button>
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col className="gutter-row tabContent" span={8}>
                                  <div>
                                    {form.getFieldValue(whichTab)?.[i]
                                      ? renderMedia(
                                        form.getFieldValue(whichTab)[i]
                                      ) // ✅ form state is always in sync
                                      : null}
                                  </div>
                                </Col>
                              </div>
                            );
                          })}
                        </>
                      );
                    }}
                  </Form.List>

                </>
              </Col>

            </>
          ) : (
            <></>
          )
          }
        </Row >
      </div >
    );
  }
}
